import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";

import { useUIStateStore } from "@/store/uiStateStore";

// import AppState from "../store/appstate";
import useAppStore from "../store/appStateZustand.js";
import H2 from "./H3";
import LoadingSmall from "./LoadingSmall";
import Spacer from "./Spacer";

function ChangeAccountModal({
  accounts,
  to,
  account,
  setSwitchModal,
}) {
  const history = useHistory();
  const { t } = useTranslation();
  const isTunecore = useUIStateStore(state => state.isTunecore);
  const setSelectedAccount = useAppStore(s => s.setSelectedAccount);
  const setSelectedCatalogue = useAppStore(s => s.setSelectedCatalogue);

  useEffect(() => {
    const timer = setTimeout(() => {
      setSwitchModal(null);
      history.push(to);
    }, 2000);

    // AppState.update((s) => {
    //   s.selectedAccount = account.artistAccountCode;
    //   s.selectedCatalogue = account.catalogueCode;
    // });
    setSelectedAccount(account.artistAccountCode);
    setSelectedCatalogue(account.catalogueCode);

    return () => clearTimeout(timer);
  }, [account.artistAccountCode, account.catalogueCode, history, setSwitchModal, to, setSelectedAccount, setSelectedCatalogue]);

  if (accounts.length === 1) {
    history.push(to);
    return <></>;
  }

  return (
    <div className="fixed top-0 left-0 z-40 flex items-center justify-center w-screen h-screen bg-black bg-opacity-50">
      <div className={`${isTunecore ? "bg-tunecore-dark-element" : "bg-white"} rounded-lg relative lg:w-1/3 w-7/8 p-8 flex items-center justify-center flex-col text-center`}>
        <LoadingSmall />
        <Spacer />
        <H2>
          {t("auth:switching-account")}
          {" "}
          <br />
          {account.name}
        </H2>
      </div>
    </div>

  );
}

export default ChangeAccountModal;
